(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("lwr-client"), require("keymirror"), require("react"), require("prop-types"), require("react-bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define(["liferay-widgets-react-web/js/liferay-widgets-react-web", "lwr-client", "keymirror", "react", "prop-types", "react-bootstrap"], factory);
	else if(typeof exports === 'object')
		exports["pub-sub-portlet"] = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("lwr-client"), require("keymirror"), require("react"), require("prop-types"), require("react-bootstrap"));
	else
		root["pub-sub-portlet"] = factory(root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["lwr-client"], root["keymirror"], root["react"], root["prop-types"], root["react-bootstrap"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_14__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	exports.Subscription = exports.UserSubscriptions = exports.UserMultiSubscriptionButton = exports.SubscriptionWebApi = exports.SubscriptionActions = undefined;
	
	var _SubscriptionActions = __webpack_require__(2);
	
	Object.defineProperty(exports, 'SubscriptionActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_SubscriptionActions).default;
	    }
	});
	
	var _StoreFactory = __webpack_require__(8);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _UserMultiSubscriptionButton = __webpack_require__(10);
	
	Object.defineProperty(exports, 'UserMultiSubscriptionButton', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_UserMultiSubscriptionButton).default;
	    }
	});
	
	var _UserSubscriptions = __webpack_require__(15);
	
	Object.defineProperty(exports, 'UserSubscriptions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_UserSubscriptions).default;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _SubscriptionWebApi = __webpack_require__(4);
	
	var _SubscriptionWebApi2 = _interopRequireDefault(_SubscriptionWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//WebApi
	
	
	exports.SubscriptionWebApi = _SubscriptionWebApi2.default;
	
	//Stores
	
	(0, _StoreFactory.getSubscriptionStore)(_liferayWidgetsReactWeb.AppContext); //Load Store by default
	
	//Components
	
	
	//Other
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: {
	        SubscriptionWebApi: _SubscriptionWebApi2.default
	    }
	});
	
	var Subscription = exports.Subscription = undefined;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _SubscriptionWebApi = __webpack_require__(4);
	
	var _SubscriptionWebApi2 = _interopRequireDefault(_SubscriptionWebApi);
	
	var _Constants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.Subscription; /**
	                                                     * Created by Carsten Bühler
	                                                     * User: CBuehler on 14.07.2017
	                                                     * Copyright: xdot GmbH 2017
	                                                     */
	
	exports.default = {
	    updateSubscription: function updateSubscription(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_SubscriptionWebApi2.default.updateSubscription, item, formId, closeForm);
	    },
	    addCurrentAccountSubscription: function addCurrentAccountSubscription(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_SubscriptionWebApi2.default.addCurrentAccountSubscription, item, formId, closeForm);
	    },
	    delete: function _delete(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_SubscriptionWebApi2.default.delete, item, formId, closeForm);
	    },
	    deleteUserSubscription: function deleteUserSubscription(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_SubscriptionWebApi2.default.deleteUserSubscription, item, formId, closeForm);
	    },
	    addOrUpdateOrDeleteMultiSubscription: function addOrUpdateOrDeleteMultiSubscription(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_SubscriptionWebApi2.default.addOrUpdateOrDeleteMultiSubscription, item, formId, closeForm);
	    },
	
	    mySubscriptionsNeeded: function mySubscriptionsNeeded() {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(_Constants.DataNames.UserSubscriptions, className, {}, _SubscriptionWebApi2.default.findMySubscriptions);
	    }
	
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(5);
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _Constants = __webpack_require__(6);
	
	var subscriptionService = function subscriptionService(m, o) {
	    return _lwrClient.Client.invoke(_Constants.Services[_Constants.ClassNames.Subscription] + m, o);
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 14.07.2017
	    * Copyright: xdot GmbH 2017
	    */
	
	var subscriptionServiceWithContext = function subscriptionServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext(_Constants.Services[_Constants.ClassNames.Subscription] + m, o, c);
	};
	
	var api = {
	    addCurrentAccountSubscription: function addCurrentAccountSubscription(_ref) {
	        var title = _ref.title,
	            topic = _ref.topic,
	            _ref$channels = _ref.channels,
	            channels = _ref$channels === undefined ? [] : _ref$channels;
	
	        return subscriptionService('add-current-account-subscription.4', {
	            title: title,
	            topic: topic,
	            channels: channels,
	            createAccount: true
	        }, {});
	    },
	    addOrUpdateOrDeleteMultiSubscription: function addOrUpdateOrDeleteMultiSubscription(_ref2) {
	        var _ref2$subscriptions = _ref2.subscriptions,
	            subscriptions = _ref2$subscriptions === undefined ? [] : _ref2$subscriptions;
	
	        return subscriptionServiceWithContext('add-or-update-or-delete-multi-subscription.2', {
	            createAccount: true
	        }, { subscriptions: subscriptions });
	    },
	    updateSubscription: function updateSubscription(_ref3) {
	        var uuid = _ref3.uuid,
	            title = _ref3.title,
	            topic = _ref3.topic,
	            _ref3$channels = _ref3.channels,
	            channels = _ref3$channels === undefined ? [] : _ref3$channels;
	
	        return subscriptionService('update-subscription.4', {
	            uuid: uuid,
	            title: title,
	            topic: topic,
	            channels: channels
	        });
	    },
	    delete: function _delete(item) {
	        return subscriptionService('delete.1', {
	            uuid: item.id
	        });
	    },
	    deleteUserSubscription: function deleteUserSubscription(item) {
	        return subscriptionService('delete-current-account-subscription-by-topic.1', {
	            topic: item.topic
	        });
	    },
	    findMySubscriptions: function findMySubscriptions() {
	        return subscriptionService('get-current-account-subscriptions.0', {
	            userId: _liferayWidgetsReactWeb.AppContext.getUserId()
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('SubscriptionWebApi', api);
	
	exports.default = api;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SendChannels = exports.DataNames = exports.Services = exports.ClassNames = undefined;
	
	var _keymirror = __webpack_require__(7);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	    Subscription: null
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 22.10.2015
	     * Copyright: xdot GmbH 2015
	     */
	
	var Services = exports.Services = {
	    Subscription: '/pub_sub.subscription/'
	};
	
	var DataNames = exports.DataNames = {
	    UserSubscriptions: 'userSubscriptions'
	};
	
	var SendChannels = exports.SendChannels = {
	    Email: 'email',
	    Push: 'push',
	    SMS: 'sms'
	};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getSubscriptionStore = getSubscriptionStore;
	
	var _SubscriptionStore = __webpack_require__(9);
	
	var _SubscriptionStore2 = _interopRequireDefault(_SubscriptionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionStoreInstance = void 0; /**
	                                         * Created by Carsten Bühler
	                                         * User: CBuehler on 29.01.2016
	                                         * Copyright: xdot GmbH 2015
	                                         */
	
	function getSubscriptionStore(AppContext) {
	  return subscriptionStoreInstance || (subscriptionStoreInstance = AppContext.createStore(_SubscriptionStore2.default));
	}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _Constants = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 22.10.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//import SubscriptionWebApi from '../webapi/SubscriptionWebApi';
	
	
	var SubscriptionStore = function (_ClassRemoteDataStore) {
	    _inherits(SubscriptionStore, _ClassRemoteDataStore);
	
	    function SubscriptionStore(Dispatcher) {
	        _classCallCheck(this, SubscriptionStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.Subscription, undefined, undefined));
	    }
	
	    SubscriptionStore.prototype.getUserSubscription = function getUserSubscription(topic) {
	        var dataItem = this.getRemoteData(_Constants.DataNames.UserSubscriptions);
	        var subscriptions = _liferayWidgetsReactWeb.DataUtil.asArray(dataItem);
	        var subscription = undefined;
	        subscriptions && subscriptions.forEach(function (sub) {
	            if (sub.topic === topic) {
	                subscription = sub;
	            }
	        });
	        return subscription;
	    };
	
	    SubscriptionStore.prototype.getContainedClassnames = function getContainedClassnames() {
	        var _ref;
	
	        return _ref = {}, _ref[_Constants.ClassNames.Subscription] = true, _ref;
	    };
	
	    return SubscriptionStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = SubscriptionStore;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _StoreFactory = __webpack_require__(8);
	
	var _SubscriptionActions = __webpack_require__(2);
	
	var _SubscriptionActions2 = _interopRequireDefault(_SubscriptionActions);
	
	var _Constants = __webpack_require__(6);
	
	var _MultiSubscriptionEditForm = __webpack_require__(13);
	
	var _MultiSubscriptionEditForm2 = _interopRequireDefault(_MultiSubscriptionEditForm);
	
	var _reactBootstrap = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 09.08.2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SubscriptionStore = (0, _StoreFactory.getSubscriptionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var MultiSubscriptionEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_MultiSubscriptionEditForm2.default);
	
	var MultiUserSubscriptionButton = function (_React$Component) {
	    _inherits(MultiUserSubscriptionButton, _React$Component);
	
	    function MultiUserSubscriptionButton(props) {
	        _classCallCheck(this, MultiUserSubscriptionButton);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            USER_SUBSCRIPTIONS: _Constants.DataNames.UserSubscriptions,
	            FORM_MULTI_SUBSCRIBE_CONFIRM: _liferayWidgetsReactWeb.UidUtil.generateId('FORM_MULTI_SUBSCRIBE_CONFIRM')
	        };
	
	        _this.removeListener = SubscriptionStore.addListener(_this.onChange.bind(_this));
	
	        _this.onSubscribe = _this.onSubscribe.bind(_this);
	        _this.onSubscribeConfirm = _this.onSubscribeConfirm.bind(_this);
	        _this.getSubscriptions = _this.getSubscriptions.bind(_this);
	
	        _this.state = {
	            'userSubscriptions': _this.getSubscriptions(),
	            'userMultiSubscriptions': _this.getUserMultiSubscriptions()
	        };
	
	        return _this;
	    }
	
	    MultiUserSubscriptionButton.prototype.componentDidMount = function componentDidMount() {
	        if (!this.getSubscriptions()) {
	            _SubscriptionActions2.default.mySubscriptionsNeeded();
	        }
	    };
	
	    MultiUserSubscriptionButton.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        if (prevProps.topics !== this.props.topics) {
	            var userMultiSubscriptions = this.getUserMultiSubscriptions();
	            this.setState({
	                userMultiSubscriptions: userMultiSubscriptions
	            });
	        }
	    };
	
	    MultiUserSubscriptionButton.prototype.onChange = function onChange() {
	        var userSubscriptionsDataItem = this.getSubscriptions();
	        var userMultiSubscriptions = this.getUserMultiSubscriptions();
	
	        this.setState({
	            'userSubscriptions': userSubscriptionsDataItem,
	            'userMultiSubscriptions': userMultiSubscriptions
	        });
	    };
	
	    MultiUserSubscriptionButton.prototype.getUserMultiSubscriptions = function getUserMultiSubscriptions() {
	        var _this2 = this;
	
	        var userSubscriptions = _liferayWidgetsReactWeb.DataUtil.asArray(this.getSubscriptions());
	        return userSubscriptions ? userSubscriptions.filter(function (sub) {
	            return _this2.props.topics.includes(sub.topic);
	        }) : undefined;
	    };
	
	    MultiUserSubscriptionButton.prototype.getSubscriptions = function getSubscriptions() {
	        return SubscriptionStore.getRemoteData(this.DATA.USER_SUBSCRIPTIONS);
	    };
	
	    MultiUserSubscriptionButton.prototype.getFormSubscriptions = function getFormSubscriptions() {
	        var _props = this.props,
	            title = _props.title,
	            topics = _props.topics;
	        var userMultiSubscriptions = this.state.userMultiSubscriptions;
	
	
	        return topics.map(function (topic) {
	            var subscription = {
	                title: title,
	                topic: topic,
	                channels: []
	            };
	
	            var matchingSubscription = userMultiSubscriptions.find(function (sub) {
	                return sub.topic === topic;
	            });
	
	            if (matchingSubscription) {
	                subscription.channels = matchingSubscription.channels;
	            }
	
	            return subscription;
	        });
	    };
	
	    MultiUserSubscriptionButton.prototype.onSubscribe = function onSubscribe(e) {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, {
	            subscriptions: this.getFormSubscriptions()
	        });
	    };
	
	    MultiUserSubscriptionButton.prototype.onSubscribeConfirm = function onSubscribeConfirm(formData) {
	        _SubscriptionActions2.default.addOrUpdateOrDeleteMultiSubscription({
	            subscriptions: formData.subscriptions
	        }, this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, true);
	    };
	
	    MultiUserSubscriptionButton.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    MultiUserSubscriptionButton.prototype.render = function render() {
	        var title = this.props.title;
	        var userMultiSubscriptions = this.state.userMultiSubscriptions;
	
	        var userHasMultiSubscription = userMultiSubscriptions && userMultiSubscriptions.length > 0;
	        var buttonTitle = 'Abonnement verwalten: ' + title;
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: userHasMultiSubscription ? 'success' : 'primary',
	                    className: 'user-subscription-button',
	                    onClick: this.onSubscribe,
	                    title: buttonTitle
	                },
	                !userHasMultiSubscription && _react2.default.createElement(_liferayWidgetsReactWeb.FaIcon, { name: 'bell', title: buttonTitle }),
	                userHasMultiSubscription && _react2.default.createElement('i', { className: 'icon icon-fliwas-bell-check', title: buttonTitle })
	            ),
	            _react2.default.createElement(MultiSubscriptionEditFormHoc, {
	                formId: this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM,
	                onFormSubmit: this.onSubscribeConfirm
	            })
	        );
	    };
	
	    return MultiUserSubscriptionButton;
	}(_react2.default.Component);
	
	MultiUserSubscriptionButton.propTypes = {
	    topics: _propTypes2.default.PropTypes.arrayOf(_propTypes2.default.string).isRequired,
	    title: _propTypes2.default.string.isRequired
	};
	
	exports.default = MultiUserSubscriptionButton;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 30.06.2016
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _Constants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiSubscriptionEditForm = function (_React$Component) {
	    _inherits(MultiSubscriptionEditForm, _React$Component);
	
	    function MultiSubscriptionEditForm(props) {
	        _classCallCheck(this, MultiSubscriptionEditForm);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    MultiSubscriptionEditForm.prototype.withCtx = function withCtx(s) {
	        return this.props.formId + '.' + s;
	    };
	
	    MultiSubscriptionEditForm.prototype.updateSubscriptions = function updateSubscriptions(topic, sendChannel, e) {
	        var subscription = this.props.formData.subscriptions.find(function (sub) {
	            return sub.topic === topic;
	        });
	
	        if (subscription) {
	            var checked = e.target.checked;
	            var channels = subscription.channels ? subscription.channels.slice() : [];
	
	            if (checked && !channels.includes(sendChannel)) {
	                channels.push(sendChannel);
	            } else if (!checked && channels.includes(sendChannel)) {
	                var index = channels.indexOf(sendChannel);
	                channels.splice(index, 1);
	            }
	
	            var updatedSubscriptions = this.props.formData.subscriptions.map(function (sub) {
	                if (sub.topic === topic) {
	                    return _extends({}, sub, { channels: channels });
	                }
	                return sub;
	            });
	
	            this.props.onChange(_extends({}, this.props.formData, {
	                subscriptions: updatedSubscriptions
	            }));
	        }
	    };
	
	    MultiSubscriptionEditForm.prototype.updateAllTopicSendChannels = function updateAllTopicSendChannels(sendChannel, activated) {
	        var updatedSubscriptions = this.props.formData.subscriptions.map(function (subscription) {
	            var channels = subscription.channels ? subscription.channels.slice() : [];
	
	            if (activated && !channels.includes(sendChannel)) {
	                channels.push(sendChannel);
	            } else if (!activated && channels.includes(sendChannel)) {
	                var index = channels.indexOf(sendChannel);
	                channels.splice(index, 1);
	            }
	
	            return _extends({}, subscription, { channels: channels });
	        });
	
	        this.props.onChange(_extends({}, this.props.formData, {
	            subscriptions: updatedSubscriptions
	        }));
	    };
	
	    MultiSubscriptionEditForm.prototype.render = function render() {
	        var _this2 = this;
	
	        var subscriptions = this.props.formData.subscriptions;
	
	        return _react2.default.createElement(
	            'fieldset',
	            null,
	            subscriptions && subscriptions.length > 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: "Abonnement verwalten: " + subscriptions[0].title }),
	                _react2.default.createElement(
	                    _reactBootstrap.Container,
	                    { className: 'py-3' },
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'multi-subscription-table' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement('th', { scope: 'col' }),
	                                _react2.default.createElement(
	                                    'th',
	                                    { scope: 'col' },
	                                    'E-Mail-Benachrichtigungen'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    { scope: 'col' },
	                                    'Push-Benachrichtigungen'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            subscriptions.map(function (subscription, index) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'th',
	                                        { scope: 'row' },
	                                        _liferayWidgetsReactWeb.translation.trans(subscription.topic.substring(0, subscription.topic.indexOf('#')))
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            null,
	                                            _react2.default.createElement(_reactBootstrap.FormCheck, {
	                                                checked: subscription.channels.includes(_Constants.SendChannels.Email),
	                                                onChange: _this2.updateSubscriptions.bind(_this2, subscription.topic, _Constants.SendChannels.Email)
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.FormGroup,
	                                            null,
	                                            _react2.default.createElement(_reactBootstrap.FormCheck, {
	                                                checked: subscription.channels.includes(_Constants.SendChannels.Push),
	                                                onChange: _this2.updateSubscriptions.bind(_this2, subscription.topic, _Constants.SendChannels.Push)
	                                            })
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        subscriptions.length > 1 && _react2.default.createElement(
	                            'tfoot',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement('td', null),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            variant: 'primary',
	                                            onClick: function onClick() {
	                                                return _this2.updateAllTopicSendChannels(_Constants.SendChannels.Email, true);
	                                            }
	                                        },
	                                        'Alles ausw\xE4hlen'
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            variant: 'outline-primary',
	                                            onClick: function onClick() {
	                                                return _this2.updateAllTopicSendChannels(_Constants.SendChannels.Email, false);
	                                            }
	                                        },
	                                        'Auswahl aufheben'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            variant: 'primary',
	                                            onClick: function onClick() {
	                                                return _this2.updateAllTopicSendChannels(_Constants.SendChannels.Push, true);
	                                            }
	                                        },
	                                        'Alles ausw\xE4hlen'
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            variant: 'outline-primary',
	                                            onClick: function onClick() {
	                                                return _this2.updateAllTopicSendChannels(_Constants.SendChannels.Push, false);
	                                            }
	                                        },
	                                        'Auswahl aufheben'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return MultiSubscriptionEditForm;
	}(_react2.default.Component);
	
	MultiSubscriptionEditForm.propTypes = {
	    formId: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    formData: _propTypes2.default.object
	};
	
	exports.default = MultiSubscriptionEditForm;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 12.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SubscriptionActions = __webpack_require__(2);
	
	var _SubscriptionActions2 = _interopRequireDefault(_SubscriptionActions);
	
	var _StoreFactory = __webpack_require__(8);
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _EditMultiSubscriptionButton = __webpack_require__(16);
	
	var _EditMultiSubscriptionButton2 = _interopRequireDefault(_EditMultiSubscriptionButton);
	
	__webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriptionStore = (0, _StoreFactory.getSubscriptionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var SUBSCRIPTION_OPTIONS = {
	    'push': 'Push',
	    'email': 'E-Mail'
	};
	
	var parseSubscriptionChannels = function parseSubscriptionChannels(keys) {
	    return Array.from(keys).map(function (k) {
	        return SUBSCRIPTION_OPTIONS[k];
	    }).join(', ');
	};
	
	var UserSubscriptions = function (_React$Component) {
	    _inherits(UserSubscriptions, _React$Component);
	
	    function UserSubscriptions(props) {
	        _classCallCheck(this, UserSubscriptions);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            USER_SUBSCRIPTIONS: 'userSubscriptions',
	            EDIT_SUBSCRIPTION_FORM: 'editSubscriptionForm',
	            DELETE_SUBSCRIPTION_CONFIRM: 'deleteSubscriptionConfirm'
	        };
	        return _this;
	    }
	
	    UserSubscriptions.getStores = function getStores() {
	        return [SubscriptionStore];
	    };
	
	    UserSubscriptions.calculateState = function calculateState(prevState, undefined, DATA) {
	        return {
	            userSubscriptions: SubscriptionStore.getRemoteData(DATA.USER_SUBSCRIPTIONS)
	        };
	    };
	
	    UserSubscriptions.prototype.componentDidMount = function componentDidMount() {
	        _SubscriptionActions2.default.mySubscriptionsNeeded();
	    };
	
	    UserSubscriptions.prototype.groupByTopicPrefix = function groupByTopicPrefix(arr) {
	        return arr.reduce(function (acc, obj) {
	            var type = obj.topic.split('#')[0].split('~')[0];
	            var name = obj.topic;
	
	            if (name.includes('~')) {
	                name = name.substring(0, name.indexOf('~')) + name.substring(name.indexOf('#'));
	            }
	
	            if (!acc[type]) {
	                acc[type] = [];
	            }
	
	            var groupIndex = acc[type].findIndex(function (group) {
	                return group.name === name;
	            });
	
	            if (groupIndex === -1) {
	                acc[type].push({
	                    name: name,
	                    items: [obj]
	                });
	            } else {
	                acc[type][groupIndex].items.push(obj);
	            }
	
	            return acc;
	        }, {});
	    };
	
	    UserSubscriptions.prototype.getTopicType = function getTopicType(topic) {
	        return topic.split('#')[0];
	    };
	
	    UserSubscriptions.prototype.render = function render() {
	        var _this2 = this;
	
	        var userSubscriptionsDataItem = this.state.userSubscriptions;
	
	        var userSubscriptionsByTopic = userSubscriptionsDataItem ? this.groupByTopicPrefix(_liferayWidgetsReactWeb.DataUtil.asArray(userSubscriptionsDataItem)) : [];
	
	        return _react2.default.createElement(
	            _liferayWidgetsReactWeb.FlagComponent,
	            { item: userSubscriptionsByTopic },
	            _react2.default.createElement(
	                'div',
	                { className: 'user-subscriptions' },
	                _react2.default.createElement(
	                    _reactBootstrap.Table,
	                    { striped: true, bordered: true, condensed: true, hover: true },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Titel'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Ereignisart'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Kan\xE4le'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Aktionen'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        Object.keys(userSubscriptionsByTopic).length === 0 && _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { colSpan: '4' },
	                                'Keine Abonnements'
	                            )
	                        ),
	                        Object.keys(userSubscriptionsByTopic).map(function (key) {
	                            var subscriptionByTopic = userSubscriptionsByTopic[key];
	                            return _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        { colSpan: '4' },
	                                        _liferayWidgetsReactWeb.translation.trans(key) + ' '
	                                    )
	                                ),
	                                subscriptionByTopic.map(function (multiSubscription) {
	                                    return _react2.default.createElement(
	                                        _react2.default.Fragment,
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { rowSpan: multiSubscription.items.length, className: 'cell-text-wrap' },
	                                                multiSubscription.items[0].title
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                { className: 'cell-text-wrap' },
	                                                multiSubscription.items.length > 1 ? _liferayWidgetsReactWeb.translation.trans(_this2.getTopicType(multiSubscription.items[0].topic)) : ''
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                null,
	                                                parseSubscriptionChannels(multiSubscription.items[0].channels)
	                                            ),
	                                            _react2.default.createElement(
	                                                'td',
	                                                { rowSpan: multiSubscription.items.length },
	                                                _react2.default.createElement(_EditMultiSubscriptionButton2.default, {
	                                                    title: 'Bearbeiten',
	                                                    objectTitle: multiSubscription.items[0].title,
	                                                    topics: [].concat(multiSubscription.items.map(function (sub) {
	                                                        return sub.topic;
	                                                    }))
	                                                })
	                                            )
	                                        ),
	                                        multiSubscription.items.map(function (item, index) {
	                                            return index > 0 && _react2.default.createElement(
	                                                'tr',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: 'cell-text-wrap' },
	                                                    _liferayWidgetsReactWeb.translation.trans(_this2.getTopicType(item.topic))
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    parseSubscriptionChannels(item.channels)
	                                                )
	                                            );
	                                        })
	                                    );
	                                })
	                            );
	                        })
	                    )
	                )
	            )
	        );
	    };
	
	    return UserSubscriptions;
	}(_react2.default.Component);
	
	UserSubscriptions.propTypes = {};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(UserSubscriptions);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(3);
	
	var _StoreFactory = __webpack_require__(8);
	
	var _SubscriptionActions = __webpack_require__(2);
	
	var _SubscriptionActions2 = _interopRequireDefault(_SubscriptionActions);
	
	var _Constants = __webpack_require__(6);
	
	var _MultiSubscriptionEditForm = __webpack_require__(13);
	
	var _MultiSubscriptionEditForm2 = _interopRequireDefault(_MultiSubscriptionEditForm);
	
	var _reactBootstrap = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 09.08.2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2018
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var SubscriptionStore = (0, _StoreFactory.getSubscriptionStore)(_liferayWidgetsReactWeb.AppContext);
	
	var MultiSubscriptionEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_MultiSubscriptionEditForm2.default);
	
	var EditMultiUserSubscriptionButton = function (_React$Component) {
	    _inherits(EditMultiUserSubscriptionButton, _React$Component);
	
	    function EditMultiUserSubscriptionButton(props) {
	        _classCallCheck(this, EditMultiUserSubscriptionButton);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            USER_SUBSCRIPTIONS: _Constants.DataNames.UserSubscriptions,
	            FORM_MULTI_SUBSCRIBE_CONFIRM: _liferayWidgetsReactWeb.UidUtil.generateId('FORM_MULTI_SUBSCRIBE_CONFIRM')
	        };
	
	        _this.removeListener = SubscriptionStore.addListener(_this.onChange.bind(_this));
	
	        _this.onSubscribe = _this.onSubscribe.bind(_this);
	        _this.onSubscribeConfirm = _this.onSubscribeConfirm.bind(_this);
	        _this.getSubscriptions = _this.getSubscriptions.bind(_this);
	
	        _this.state = {
	            'userSubscriptions': _this.getSubscriptions(),
	            'userMultiSubscriptions': _this.getUserMultiSubscriptions()
	        };
	
	        return _this;
	    }
	
	    EditMultiUserSubscriptionButton.prototype.componentDidMount = function componentDidMount() {
	        if (!this.getSubscriptions()) {
	            _SubscriptionActions2.default.mySubscriptionsNeeded();
	        }
	    };
	
	    EditMultiUserSubscriptionButton.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        if (prevProps.topics !== this.props.topics) {
	            var userMultiSubscriptions = this.getUserMultiSubscriptions();
	            this.setState({
	                userMultiSubscriptions: userMultiSubscriptions
	            });
	        }
	    };
	
	    EditMultiUserSubscriptionButton.prototype.onChange = function onChange() {
	        var userSubscriptionsDataItem = this.getSubscriptions();
	        var userMultiSubscriptions = this.getUserMultiSubscriptions();
	
	        this.setState({
	            'userSubscriptions': userSubscriptionsDataItem,
	            'userMultiSubscriptions': userMultiSubscriptions
	        });
	    };
	
	    EditMultiUserSubscriptionButton.prototype.getUserMultiSubscriptions = function getUserMultiSubscriptions() {
	        var _this2 = this;
	
	        var userSubscriptions = _liferayWidgetsReactWeb.DataUtil.asArray(this.getSubscriptions());
	        return userSubscriptions ? userSubscriptions.filter(function (sub) {
	            return _this2.props.topics.includes(sub.topic);
	        }) : undefined;
	    };
	
	    EditMultiUserSubscriptionButton.prototype.getSubscriptions = function getSubscriptions() {
	        return SubscriptionStore.getRemoteData(this.DATA.USER_SUBSCRIPTIONS);
	    };
	
	    EditMultiUserSubscriptionButton.prototype.getFormSubscriptions = function getFormSubscriptions() {
	        var _props = this.props,
	            objectTitle = _props.objectTitle,
	            topics = _props.topics;
	        var userMultiSubscriptions = this.state.userMultiSubscriptions;
	
	
	        return topics.map(function (topic) {
	            var subscription = {
	                title: objectTitle,
	                topic: topic,
	                channels: []
	            };
	
	            var matchingSubscription = userMultiSubscriptions.find(function (sub) {
	                return sub.topic === topic;
	            });
	
	            if (matchingSubscription) {
	                subscription.channels = matchingSubscription.channels;
	            }
	
	            return subscription;
	        });
	    };
	
	    EditMultiUserSubscriptionButton.prototype.onSubscribe = function onSubscribe(e) {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, {
	            subscriptions: this.getFormSubscriptions()
	        });
	    };
	
	    EditMultiUserSubscriptionButton.prototype.onSubscribeConfirm = function onSubscribeConfirm(formData) {
	        _SubscriptionActions2.default.addOrUpdateOrDeleteMultiSubscription({
	            subscriptions: formData.subscriptions
	        }, this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, true);
	    };
	
	    EditMultiUserSubscriptionButton.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    EditMultiUserSubscriptionButton.prototype.render = function render() {
	        var _props2 = this.props,
	            objectTitle = _props2.objectTitle,
	            title = _props2.title;
	
	        var buttonTitle = 'Abonnement bearbeiten: ' + objectTitle;
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'primary',
	                    onClick: this.onSubscribe,
	                    title: buttonTitle
	                },
	                title
	            ),
	            _react2.default.createElement(MultiSubscriptionEditFormHoc, {
	                formId: this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM,
	                onFormSubmit: this.onSubscribeConfirm
	            })
	        );
	    };
	
	    return EditMultiUserSubscriptionButton;
	}(_react2.default.Component);
	
	EditMultiUserSubscriptionButton.propTypes = {
	    topics: _propTypes2.default.PropTypes.arrayOf(_propTypes2.default.string).isRequired,
	    title: _propTypes2.default.string.isRequired,
	    objectTitle: _propTypes2.default.string.isRequired
	};
	
	exports.default = EditMultiUserSubscriptionButton;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(18);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_notifications.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_notifications.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".user-subscriptions .cell-text-wrap{max-width:20rem;overflow-wrap:break-word}.user-subscriptions table tr td:first-child{padding-left:.75rem}.user-subscriptions table tr td:last-child{padding-right:.75rem}", ""]);
	
	// exports


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// pub-sub-portlet.js